import { useState } from 'react';
import { MetricsRate } from '../../../../../../model/ReportingMetrics';
import { MetricsTileComponent } from '../core/MetricsTile/MetricsTile';
import NumericalValueTile from '../core/NumericalTile/NumericalTile';
import { useFormattedMetricsValues } from '../core/NumericalTile/NumericalTile.utils';
import { Button } from '@fluentui/react-components';
import { NumberSymbolSquareRegular } from '@fluentui/react-icons';
import { formatPercentage } from '../../../../../../utils/formatters';
import { useTranslation } from 'react-i18next';

export interface RateTileProps {
    previousValue: MetricsRate;
    currentValue: MetricsRate;
    countTooltip?: string;
    totalCountTooltip?: string;
}

const RateTile: MetricsTileComponent<RateTileProps> = ({
    title,
    previousValue,
    currentValue,
    countTooltip,
    totalCountTooltip,
    className,
}) => {
    const { t } = useTranslation();

    const absoluteValues = useFormattedMetricsValues(
        [
            {
                label: t('ReportingDashboard_RateTile_Count'),
                labelTooltip: countTooltip,
                previous: previousValue.count,
                current: currentValue.count,
            },
            {
                label: t('ReportingDashboard_RateTile_TotalCount'),
                labelTooltip: totalCountTooltip,
                previous: previousValue.totalCount,
                current: currentValue.totalCount,
            },
        ],
        { size: 'small' }
    );

    const rateValue = useFormattedMetricsValues(
        [
            {
                previous: previousValue.rateValue,
                current: currentValue.rateValue,
            },
        ],
        { valueFormatter: formatPercentage }
    );

    const [showRate, setShowRate] = useState(true);

    return (
        <NumericalValueTile
            title={title}
            titleActions={
                <Button
                    icon={<NumberSymbolSquareRegular />}
                    appearance="subtle"
                    onClick={() => setShowRate((x) => !x)}
                >
                    {t('ReportingDashboard_RateTile_ToggleDisplay')}
                </Button>
            }
            values={showRate ? rateValue : absoluteValues}
            className={className}
        />
    );
};

export default RateTile;
